import { render, staticRenderFns } from "./HubFeatures.vue?vue&type=template&id=31daa6c6&"
import script from "./HubFeatures.vue?vue&type=script&lang=js&"
export * from "./HubFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports